import { Facebook, Instagram, Twitter, Linkedin, Youtube, ArrowRight, Mail } from "lucide-react";
import logo from "@/assets/images/UrbNetLogoSemFundo.png";

export function LandingFooter() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="relative overflow-hidden">
      {/* CTA band */}
      <div className="relative bg-gradient-to-r from-primary to-secondary py-20">
        <div className="absolute inset-0 opacity-10 text-primary-foreground">
          <svg className="h-full w-full" viewBox="0 0 1440 320" preserveAspectRatio="none">
            <path
              fill="currentColor"
              d="M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,181.3C960,181,1056,235,1152,234.7C1248,235,1344,181,1392,154.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"
            />
          </svg>
        </div>
        <div className="relative mx-auto max-w-7xl px-6 text-center">
          <h2 className="font-heading text-3xl font-bold text-primary-foreground sm:text-4xl">
            Vamos conversar?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-primary-foreground/80">
            Precisa de ajuda? Envie um e-mail para
          </p>
          <a
            href="mailto:contato@urbnet.app.br"
            className="mt-2 inline-flex items-center gap-2 text-lg font-semibold text-primary-foreground underline underline-offset-4 transition-opacity hover:opacity-80"
          >
            <Mail className="h-5 w-5" />
            contato@urbnet.app.br
          </a>
        </div>
      </div>

      {/* Links band */}
      <div className="bg-foreground py-16 text-background">
        <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-4 sm:grid-cols-2 lg:grid-cols-[1.2fr_1fr_1fr_1fr] md:px-6">
          {/* Brand */}
          <div className="flex flex-col gap-6">
            <a href="/" className="flex items-center gap-3">
              <img src={logo} alt="UrbNet" className="h-12 w-auto" />
            </a>
            <div className="flex items-center gap-4">
              {[
                { icon: Instagram, label: "Instagram", href: "#" },
                { icon: Youtube, label: "YouTube", href: "#" },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  aria-label={social.label}
                  className="flex h-9 w-9 items-center justify-center rounded-full bg-background/10 text-background transition-colors hover:bg-background/20"
                >
                  <social.icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          {/* Sobre nós */}
          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-primary-light">Sobre nós</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="/" className="text-background/70 transition-colors hover:text-background">Home</a>
              </li>
              <li>
                <a href="/quem-somos" className="text-background/70 transition-colors hover:text-background">Quem somos</a>
              </li>
              <li>
                <a href="#" className="text-background/70 transition-colors hover:text-background">Notícias</a>
              </li>
            </ul>
          </div>

          {/* Soluções */}
          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-primary-light">Soluções</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <a href="#recursos" className="text-background/70 transition-colors hover:text-background">Sou Governo</a>
              </li>
              <li>
                <a href="https://urbnet.app.br" className="text-background/70 transition-colors hover:text-background">Sou Cidadão</a>
              </li>
            </ul>
          </div>

          {/* Fale Conosco */}
          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wider text-primary-light">Fale Conosco</h3>
            <a
              href="/solicitar-orcamento"
              className="inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-primary to-secondary px-5 py-2.5 text-sm font-semibold text-primary-foreground shadow-lg shadow-secondary/20 transition-all hover:-translate-y-0.5 hover:shadow-secondary/30"
            >
              Solicite orçamento
              <ArrowRight className="h-4 w-4" />
            </a>
          </div>
        </div>

        {/* Copyright */}
        <div className="mx-auto mt-16 flex max-w-7xl flex-col items-center justify-between gap-4 border-t border-background/10 px-6 pt-8 text-xs text-background/50 sm:flex-row">
          <p>Todos os direitos reservados © {currentYear} UrbNet</p>
          <div className="flex items-center gap-6">
            <a href="/politica-privacidade" className="hover:text-background/80">Política de Privacidade</a>
            <a href="/termos-uso" className="hover:text-background/80">Termos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
